import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Learnspace } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';

@Component({
  selector: 'program-settings',
  templateUrl: './program-settings.component.html',
  styleUrls: ['./program-settings.component.scss'],
  animations: fuseAnimations
})
export class ProgramSettingsComponent implements OnInit {
  @Input() learnspace: Learnspace;
  @Output() learnspaceChange = new EventEmitter<Learnspace>

  constructor(private _courseApiService: CoursesAPIService) {}

  async ngOnInit() {}
  onLearnspaceChange(ls: Learnspace) {
    this.learnspace = { ...this.learnspace, ...ls };
    this._courseApiService.updateLearnspace(this.learnspace.id, this.learnspace).subscribe(ls => {
      this.learnspaceChange.emit(this.learnspace);
    });
  }
}
